<template>
    <main id="machine-sheet-documents" v-if="displayContent">
        <div class="wrapper">

            <div class="titled-container documents-container" v-if="documents.length > 0">
                <h2 class="title is-2">
                    {{ $t("documents") }}
                </h2>
                <!-- <sheet-block-associated-brochures :documents="brochures" v-if="getEnv!=='production' && brochures.length > 0"/>-->
                <sheet-block-associated-documents :documents="documents"/>
            </div>

            <div class="titled-container reduce-risks-container" v-if="reduceRisksVideos.length > 0">
                <h2 class="title is-2">
                    {{ $t("reduce_risks") }}
                </h2>
                <div class="item-list">
                    <a
                            v-for="reduceRisksVideo in reduceRisksVideos"
                            :key="reduceRisksVideo.code"
                            class="item"
                            data-mediabox="reduce-risks-gallery"
                            :href="reduceRisksVideo.embed+'?autoplay=1'"
                            :data-width="lightboxVideoWidth"
                            :data-height="lightboxVideoHeight"
                            @click="enableBlur()"
                    >
                        <div class="video-badge is-large" aria-label="Video badge"></div>
                        <h4 class="name">
                            {{ reduceRisksVideo.title }}
                        </h4>
                    </a>
                </div>
            </div>

            <div class="content-available-soon" v-if="documents.length===0 && reduceRisksVideos.length===0">
                {{ $t('content_available_soon') }}
            </div>
        </div>
    </main>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import speedTrackingMixins from "@/common/mixins/speedTracking"
//import assetService from "@/services/akeneo/asset"
import assetService from '@/services/serli/asset'

import SheetBlockAssociatedDocuments from "@/components/SheetBlock/SheetBlockAssociatedDocuments";
import SheetBlockAssociatedBrochures from "@/components/SheetBlock/SheetBlockAssociatedBrochures";

import {MEDIA_URL} from "@/common/config";
import {localeToKebabCase, slugify} from "@/common/helpers";
import store from "@/store";
import playlistService from "@/services/youtube/playlist";
import productService from "@/services/serli/product";

export default {
    name: 'MachineDocumentsView',
    mixins: [
        speedTrackingMixins
    ],
    components: {
        SheetBlockAssociatedDocuments,
        SheetBlockAssociatedBrochures,
    },
    data() {
        return {
            displayContent: false,
            walkaroundVideo: null,
            reduceRisksVideos: [],
            documents: [],
            brochures: [],
            distinctDocumentsCode: [],
            excludes: [
                'aerial_work_platforms',
                'robotics_solutions',
                'warehousing',
                'truck_mounted_forklifts'
            ]
        }
    },
    computed: {
        ...mapState({
            productDatas: state => state.sheet.productDatas,
            country: state => state.settings.country,
            unitType: state => state.settings.unitType,
        }),
        ...mapGetters({
            localeKebabFormat: 'settings/localeKebabFormat'
        }),
    },
    created() {
        this.startLoading();
        this.getAssetsData();
    },
    methods: {
        loadData() {
            let promisesArray = [
              this.fetchAllDocuments()
            ];

            this.speedTrackingShowroom = new Date().getTime();

            Promise.all(promisesArray).then(() => {

              this.stopLoading()
              this.displayContent = true;

              let promisesArrayDocuments = [
                this.fetchReduceRisks(),
              ];

              this.speedTrackingDocuments = new Date().getTime();
              return Promise.all(promisesArrayDocuments);

            }).finally(() => {
              this.$nextTick(() => {
                if (this.documents.length)
                  this.speedTrackingDocumentsTrigger('machine', this.productDatas.identifier, this.productDatas.values.reference_name);

                if (this.reduceRisksVideos.length > 0)
                  this.$root.wamediabox.bindAll(document.querySelector(".reduce-risks-container"));
              })
            });

            this.speedTrackingShowroomTrigger('machine', this.productDatas.identifier, this.productDatas.values.reference_name);
        },
        async getAssetsData() {
          if (!this.productDatas.assets.length) {
            // this.startLoading();
            // console.log('get data')
            await productService.getAssets(this.productDatas.identifier, {locale: this.localeKebabFormat})
              .then(response => {
                console.log(response.data)
                let productDatasStored = this.productDatas;
                productDatasStored.assets = response.data.data;

                this.$store.commit('sheet/setProductDatas', productDatasStored);
              })
              .finally(() => this.loadData());
          } else this.loadData()
        },
        async fetchAllDocuments() {
            let documentsAttributes = [
                'handover_guide',
                'brochures',
                'product_custom_documents',
                'documents',
                'competition',
                'sales_training',
                'product_training',
                'product_card'
            ];

            for (const documentsAttribute of documentsAttributes)
                this.fetchDocuments(documentsAttribute)
            /*
            if (this.productDatas.categories) {
              for (var index in this.productDatas.categories) {
                let rangeAssets = await assetService.categoryList(this.productDatas.categories[index]).then((response) => response.data.data);
                for (const rangeAsset of rangeAssets) {
                  await assetService.download(rangeAsset.code, {
                    type: 'document',
                    locale: this.$store.state.settings.locale
                  }).then(async response => {
                    if (response.data.data === null && this.$store.state.settings.locale !== 'en_US') {
                      await assetService.download(rangeAsset.code, {type: 'document', locale: 'en_US'}).then(response => {
                        if (response.data.data !== null) {
                          let rd = response.data.data;
                          if (!this.documents.find(x => x.identifier === rd.code)) {
                            this.documents.push({
                              identifier: rd.code,
                              documentsAttribute: rangeAsset.code,
                              code: rd.code,
                              extension: rd.extension,
                              filename: rd.filename,
                              name: this.$_.replace(rd.code, /_/g, ' '),
                              isSerli: true,
                              link: MEDIA_URL + '/view/assets/' + rangeAsset.code,
                            });
                          }
                        }
                      });
                    } else if (response.data.data !== null) {
                      let rd = response.data.data;
                      if (!this.documents.find(x => x.identifier === rd.code)) {
                        this.documents.push({
                          identifier: rd.code,
                          documentsAttribute: rangeAsset.code,
                          code: rd.code,
                          extension: rd.extension,
                          filename: rd.filename,
                          name: this.$_.replace(rd.code, /_/g, ' '),
                          isSerli: true,
                          link: MEDIA_URL + '/view/assets/' + rangeAsset.code,
                        });
                      }
                    }
                  });
                }
              }
            }
            */


            //if (this.getEnv !== 'production')
            //console.log(this.productDatas.options)

            //find range
            let range = this.productDatas.productRanges[0].find(x => x.parent==='machines');

            if(!this.excludes.includes(range.code)) {
            this.documents.unshift(
                {
                    'type': "attachment-guide",
                    'machine': this.productDatas.attachments_products.length > 0,
                    'category': true,
                    'markets': true,
                },

                {
                   'type': "machine-book",
                     'machine': true,
                     'category' : true,
                     'markets' : true,
                 },
                /*    {
                      'type': "option-guide",
                      'machine': this.productDatas.options.finition_standard || this.productDatas.options.finition_option  ,
                      'category' : true,
                      'markets' : true,
                    },*/
            )
            }
            // console.log(this.documents)
            /*
                  this.brochures.forEach(brochure => {
                      if(brochure.machineId)
                      this.documents.push({
                        identifier: brochure.type,
                        name: this.$t(brochure.type)+' - '+this.productDatas.name,
                        link: `https://technical-datasheet-api.staging.manitou.com/brochures/${brochure.type}?country=${this.country}&locale=${this.localeKebabFormat}&unit=${this.unitType}&machineId=${brochure.machineId}&format=pdf`,
                        extension: 'pdf',
                        filename: `${slugify(this.productDatas.name)}-${brochure.type}.pdf`,
                        forceLinkDownload: true,
                        product: this.productDatas,
                      })

                    if(brochure.machineCategory)
                      this.documents.push({
                        identifier: brochure.type,
                        name: this.$t(brochure.type)+' - '+brochure.machineCategory,
                        link: `https://technical-datasheet-api.staging.manitou.com/brochures/${brochure.type}?country=${this.country}&locale=${this.localeKebabFormat}&unit=${this.unitType}&machineCategory=${brochure.machineCategory}&format=pdf`,
                        extension: 'pdf',
                        filename: `${slugify(brochure.machineCategory)}-${brochure.type}.pdf`,
                        forceLinkDownload: true,
                        product: this.productDatas,
                      })

                  })
            */

        },
        fetchDocuments(documentsAttribute) {
            const documents = this.productDatas.assets.filter((d) => d.attribute === documentsAttribute);
            const locale = this.localeKebabFormat.replace('-', '_')
            let link = ''
            let name = ''
            if (documents)
                documents.forEach((document) => {
                    link = document.links.download[locale] ? document.links.download[locale] : document.links.download['en_US']
                    name = document.code.substring(0, document.code.indexOf('.'));
                    if (link)
                        this.documents.push({
                            identifier: document.code,
                            documentsAttribute: documentsAttribute,
                            code: document.code,
                            extension: document.type,
                            filename: document.code,
                            name: this.$_.replace(name, /_/g, ' '),
                            link: link,
                        });
                })

        },
        /*
        async fetchDocuments(documentsAttribute) {
          if (this.productDatas.values[documentsAttribute] !== undefined) {
            for (const document of this.productDatas.values[documentsAttribute]) {

              if (!this.distinctDocumentsCode.includes(document)) {
                this.distinctDocumentsCode.push(document);
                await assetService.download(document.replace('/view/assets/', ''), {
                  type: 'document',
                  locale: this.$store.state.settings.locale
                }).then(async response => {
                  if (response.data.data === null && this.$store.state.settings.locale !== 'en_US') {
                    await assetService.download(document.replace('/view/assets/', ''), {
                      type: 'document',
                      locale: 'en_US'
                    }).then(response => {
                      if (response.data.data !== null) {
                        let rd = response.data.data;
                        this.documents.push({
                          identifier: rd.code,
                          documentsAttribute: documentsAttribute,
                          code: rd.code,
                          extension: rd.extension,
                          filename: rd.filename,
                          name: this.$_.replace(rd.code, /_/g, ' '),
                          link: MEDIA_URL + "/" + document,
                        });
                      }
                    });
                  } else if (response.data.data !== null) {
                    let rd = response.data.data;
                    this.documents.push({
                      identifier: rd.code,
                      documentsAttribute: documentsAttribute,
                      code: rd.code,
                      extension: rd.extension,
                      filename: rd.filename,
                      name: this.$_.replace(rd.code, /_/g, ' '),
                      link: MEDIA_URL + "/" + document,
                    });
                  }
                });
              }
            }
          }
        },

         */
        fetchReduceRisks() {
            if (this.productDatas.values['youtube_reduce_program']) {
                //Correctif pour mauvaise qualification
                if (this.productDatas.values['youtube_reduce_program'].code.indexOf('&list=') > 1) this.productDatas.values['youtube_reduce_program'].code = this.productDatas.values['youtube_reduce_program'].code.split('&list=')[1]
                return playlistService.getVideos(this.productDatas.values['youtube_reduce_program'].code, {withDetails: true}).then((response) => {
                    if (response.data.data)
                        this.reduceRisksVideos = response.data.data
                })
            }
        },
    }
}
</script>


<style lang="scss">
#machine-sheet-documents {
  padding-top: 35px;
  padding-bottom: 40px;

  .reduce-risks-container {
    .item-list {
      margin: 0 -10px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: left;

      @media #{$mq_phone} {
        margin: 0;
      }

      .item {
        flex: 0 0 calc((100% / 6) - 20px);
        display: flex;
        align-items: center;
        padding: 0 15px;
        margin: 10px;
        height: 80px;
        background-color: $light-grey;
        transition: background-color 0.3s ease;

        @media #{$mq_large_desktop} {
          flex: 0 0 calc((100% / 5) - 20px);
        }

        @media #{$mq_small_desktop} {
          flex: 0 0 calc((100% / 4) - 20px);
        }

        @media #{$mq_tablet} {
          flex: 0 0 calc((100% / 3) - 20px);
        }

        @media #{$mq_phone} {
          flex: 0 0 100%;
          margin: 0 0 20px 0;
        }

        &:hover {
          background-color: darken($light-grey, 10);
        }

        .video-badge {
          flex: 0 0 42px;
          margin-right: 20px;
        }

        .name {
          flex: 1 1 auto;
          font-size: 13px;
          font-weight: 700;
          line-height: 1.15;
        }
      }
    }
  }

}
</style>

